<ng-container>
  <!--
    GPE customization (gov.ao): the filter as a pane, not a row.

    This used to be one line - name, operator, value, remove - inside a list of
    every filter in use. The name is in the panel's left column now, and what is
    left is laid out down the right one under headings of its own.
  -->

  <!-- Operator -->
  <div class="op-filter-panel--field advanced-filters--filter-operator"
       *ngIf="valueType === '[1]Boolean'">
    <span class="op-filter-panel--field-label" [textContent]="text.value"></span>
    <op-filter-boolean-value
      (filterChanged)="onFilterUpdated($event)"
      [shouldFocus]="shouldFocus"
      [filter]="filter"
    ></op-filter-boolean-value>
  </div>

  <ng-container *ngIf="valueType !== '[1]Boolean'">
    <!--
      Radio buttons while there are few enough operators to read as a list of
      choices, and a select once there are not: a date filter offers eleven.
    -->
    <fieldset class="op-filter-panel--field advanced-filters--filter-operator"
              *ngIf="radioOperators; else operatorSelect">
      <legend class="op-filter-panel--field-label" [textContent]="text.condition"></legend>
      <div class="op-filter-panel--choice"
           *ngFor="let operator of availableOperators; trackBy: trackByHref">
        <!--
          [checked] and (change) rather than ngModel: the operator is a HAL
          resource, and the one the filter holds is not always the same object as
          the one in this list. A select can be told how to compare them with
          compareWith; a radio group has no such thing, and would simply show
          none of them as chosen.
        -->
        <input type="radio"
               class="op-filter-panel--radio"
               [id]="'operator-' + filter.id + '-' + operator.id"
               [attr.name]="'operator_' + filter.id"
               [checked]="operator.href === filter.operator?.href"
               (change)="setOperator(operator)">
        <label class="op-filter-panel--choice-label"
               [attr.for]="'operator-' + filter.id + '-' + operator.id"
               [textContent]="operator.name"></label>
      </div>
    </fieldset>

    <ng-template #operatorSelect>
      <div class="op-filter-panel--field advanced-filters--filter-operator">
        <label class="op-filter-panel--field-label"
               [attr.for]="'operators-' + filter.id"
               [textContent]="text.condition"></label>
        <select
          required
          class="advanced-filters--select"
          id="operators-{{filter.id}}"
          name="op[{{filter.id}}]"
          [(ngModel)]="filter.operator"
          (ngModelChange)="onFilterUpdated(filter)"
          [compareWith]="compareByHref"
        >
          <option
            *ngFor="let operator of availableOperators"
            [textContent]="operator.name"
            [ngValue]="operator"
          >
          </option>
        </select>
      </div>
    </ng-template>
  </ng-container>

  <!-- Values -->
  <ng-container *ngIf="showValuesInput && valueType">
    <div class="op-filter-panel--field">
      <span class="op-filter-panel--field-label" [textContent]="text.value"></span>
      <div class="advanced-filters--filter-value" [ngSwitch]="valueType">
        <op-filter-integer-value
          *ngSwitchCase="'[1]Integer'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-integer-value>

        <op-filter-date-value
          *ngSwitchCase="'[1]Date'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-date-value>

        <op-filter-dates-value
          *ngSwitchCase="'[2]Date'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-dates-value>

        <op-filter-date-time-value
          *ngSwitchCase="'[1]DateTime'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-date-time-value>

        <op-filter-date-times-value
          *ngSwitchCase="'[2]DateTime'"
          [shouldFocus]="shouldFocus"
          (filterChanged)="onFilterUpdated($event)"
          [filter]="filter"
        ></op-filter-date-times-value>

        <op-filter-string-value
          *ngSwitchCase="'[1]String'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-string-value>

        <op-filter-string-value
          *ngSwitchCase="'[1]Float'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-string-value>

        <op-filter-project
          *ngSwitchCase="'[]Project'"
          (filterChanged)="onFilterUpdated($event)"
          [shouldFocus]="shouldFocus"
          [filter]="filter"
        ></op-filter-project>

        <ng-container *ngSwitchDefault>
          <op-filter-toggled-multiselect-value
            *ngIf="filter.currentSchema.loadedAllowedValues()"
            (filterChanged)="onFilterUpdated($event)"
            [shouldFocus]="shouldFocus"
            [filter]="filter"
          ></op-filter-toggled-multiselect-value>
          <op-filter-searchable-multiselect-value
            *ngIf="!filter.currentSchema.loadedAllowedValues()"
            (filterChanged)="onFilterUpdated($event)"
            [shouldFocus]="shouldFocus"
            [filter]="filter"
          ></op-filter-searchable-multiselect-value>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!--
    The warning that this filter cannot be read against the baseline. It used to
    be a word next to the name; the name is in the other column now, so it is
    said here in full.
  -->
  <div class="op-filter-panel--field"
       *ngIf="baselineIncompatibleFilter"
       data-test-selector="query-filter-baseline-incompatible">
    <div class="op-toast -warning">
      <div class="op-toast--content">
        <p [textContent]="text.incompatible_filter"></p>
      </div>
    </div>
  </div>
</ng-container>
